<template>
    <ul
        v-if="messageContainer.messages && messageContainer.messages.length > 0"
        class="inbox-messages p-3 overflow-auto text-right"
        ref="messageView"
    >
        <template v-if="type === 'contact'">
            <inbox-message v-for="message in messageContainer.messages" :key="message.tra_id" :message="message" />
        </template>
        <template v-else>
            <inbox-message-deliverable v-for="md in messageContainer.messages" :key="md.tra_id" :md="md" />
        </template>
    </ul>
    <div v-else class="p-4 flex items-center justify-center h-96 bg-gray-100">
        <em class="text-gray-600 text-xl">No messages to display</em>
    </div>
</template>
<script>

    import InboxMessage from "./InboxMessage";
    import InboxMessageDeliverable from "./InboxMessageDeliverable";

    export default {
        props: {
            messageContainer: {
                type: Object,
                default: () => {
                    return {}
                }
            },
            type: {
                type: String,
                default: 'contact'
            },
        },
        components: {
            InboxMessage,
            InboxMessageDeliverable
        },
        methods: {
            scrollToBottom () {
                if (this.$refs.messageView) {
                    this.$refs.messageView.scrollTop = this.$refs.messageView.scrollHeight;
                }
            },
        },
        computed: {
        },
        mounted() {
            this.scrollToBottom();
        }
    }
</script>

<style scoped>
    .inbox-messages {
        height: 400px;
    }
</style>
